import React, { useEffect, useState } from 'react'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'; // Replaced Ant Design icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Removed Empty, Input, Modal imports
import { API } from 'aws-amplify'
import get from 'lodash/get'
// Added CBInput, CBModal, CBEmpty imports
import { CBInput, CBModal } from '../../core/components/cbd';
import { CBEmpty } from '../../core/components/CBEmpty';
import { CBButton } from '../../core/components/cbd'; // Added CBButton for Search
import QueryString from 'query-string'

import JSONTree from 'react-json-tree'
import BoomerScanAccountList from './BoomerScanAccountList'
import BoomerScanBridgeList from './BoomerScanBridgeList'
import LicenseInfo from './LicenseInfo'

const theme = {
  scheme: 'google',
  author: 'seth wright (http://sethawright.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#CC342B',
  base09: '#F96A38',
  base0A: '#FBA922',
  base0B: '#198844',
  base0C: '#3971ED',
  base0D: '#3971ED',
  base0E: '#A36AC7',
  base0F: '#3971ED',
}

const PAGE_LIMIT = 100

const BoomerScan = () => {
  const [boomerData, setBoomerData] = useState({})
  const [userEmail, setUserEmail] = useState('')

  const [search, setSearch] = useState(null)
  const [loading, setLoading] = useState(false)
  const [forceRefresh, setForceRefresh] = useState(false)
  const [bridges, setBridges] = useState([])
  const [accounts, setAccounts] = useState([])
  // State for confirmation modal
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [accountToDelete, setAccountToDelete] = useState(null);


  async function loadBoomerData() {
    if (userEmail.length) {
      setBoomerData({})
      setBridges([])
      setAccounts([])
      setLoading(true)
      try {
        var responseBoomerData = await API.get('scan', '/scan', {
          queryStringParameters: {
            email: userEmail,
            target: search,
            action: 'getBoomerData',
          },
        })
        console.log(responseBoomerData)
        setBoomerData(get(responseBoomerData, 'results'))
        setAccounts(get(responseBoomerData, ['results', 'accounts']) || [])
        setBridges(get(responseBoomerData, ['results', 'bridges']) || [])
      } catch (ex) {
        alert(ex.message)
      } finally {
        setLoading(false)
      }
    }
  }

  async function deleteCalendarAccount(accountId) {
    if (userEmail.length) {
      // Set state to show modal instead of calling Modal.confirm
      setAccountToDelete(accountId);
      setIsModalVisible(true);
    }
  }

  // Function to handle the actual deletion, called by the modal
  const handleConfirmDelete = async () => {
    if (!accountToDelete) return;

    setIsModalVisible(false); // Close modal first
    setLoading(true);
    try {
      await API.post('scan', '/scan', {
        body: {
          email: accountToDelete, // Use the stored accountId
          action: 'deleteCalendarAccount',
        },
      });
      setForceRefresh(true); // Trigger data refresh
    } catch (ex) {
      alert(ex.message);
    } finally {
      setLoading(false);
      setAccountToDelete(null); // Reset account to delete
    }
  };

  useEffect(() => {
    let params = QueryString.parse(location.search)
    if (params.userEmail) {
      // console.log(params.userEmail)
      setUserEmail(params.userEmail)

      setForceRefresh(true)
    }
  }, [])

  useEffect(() => {
    if (forceRefresh) {
      loadBoomerData()
      setForceRefresh(false)
    }
  }, [forceRefresh])

  async function updateEmailAndLoadNewData(email) {
    setUserEmail(email)
    setForceRefresh(true)
  }

  return (
    <>
    <div id="top" className="container"></div>
      {/* Replaced Input.Search with CBInput and CBButton */}
      <div className="flex gap-2 mb-4 items-center"> {/* Added flex container */}
      <div className="lg:w-1/2 w-2/3 ">
        <CBInput
          style={{width:'800px'}}
          placeholder="User Email"
          // size="large" - Control size via className if needed
          value={userEmail}
          onChange={(val) => { // CBInput typically passes value directly
            setUserEmail(val.toLowerCase().trim())
          }}
          onKeyDown={(e) => e.key === 'Enter' && loadBoomerData()} // Trigger search on Enter
           // Allow input to grow and prevent overflow issues
        />
        </div>
        <CBButton
          onClick={loadBoomerData}
          loading={loading}
          type="primary" // Style as primary button
        >
          Scan
        </CBButton>
      </div>
      {Object.keys(boomerData).length > 0 ? (
        <div className="p-5"> {/* Replaced style with Tailwind */}
          {boomerData['license'] && (
            <LicenseInfo
              license={boomerData['license']}
              updateEmailAndLoadNewData={updateEmailAndLoadNewData}
            />
          )}
          {search && boomerData['targets'] && (
            <>
              <h3>Search Results</h3>
              <JSONTree
                data={{ items: boomerData['targets'] }}
                hideRoot={true}
                theme={theme}
              />
            </>
          )}
          <a href="#syncs">Jump to syncs</a>
          {accounts.length && (
            <BoomerScanAccountList
              userEmail={userEmail}
              theme={theme}
              initialAccounts={accounts}
              pageLimit={PAGE_LIMIT}
              deleteCallback={deleteCalendarAccount}
            />
          )}
          <a id="syncs"></a>
          <a href="#top">back to top</a>
          {bridges.length && (
            <BoomerScanBridgeList
              userEmail={userEmail}
              initialBridges={bridges}
              theme={theme}
              pageLimit={PAGE_LIMIT}
              accounts={accounts}
            />
          )}
          <div>
            Schedules:
            {boomerData['schedules'] && (
             <div>
              {boomerData['schedules'].map(item=>{
                return <div className="border p-3">
                  {item.label || item.displayName}
                  {' '} id:{' '} {item.id}
                  alias:{' '} {item.alias}
                  
                  <JSONTree
                data={{scheduler: item}}
                hideRoot={true}
                theme={theme}
              />
              {item.errorState != "" && <div>Error: {item.errorState}</div>}
                <div><a href={`/book/${item.id}?debug=true`} target="_blank">Open Debugger</a></div>
              </div>
              })}
             </div>)}
           
            </div>
         
        </div>
      ) : (
        <div className="p-5"> {/* Replaced style with Tailwind */}
          {/* Replaced Empty with CBEmpty */}
          <CBEmpty description="No data found for this user." />
        </div>
      )}
      {/* Add the CBModal component */}
      <CBModal
        visible={isModalVisible}
        title="Confirm Deletion"
        onPositiveClick={handleConfirmDelete}
        onCancelClick={() => {
          setIsModalVisible(false);
          setAccountToDelete(null);
        }}
        positiveLabel="Delete"
        negativeLabel="Cancel"
        // Add loading state to positive button if CBModal supports it
        // confirmLoading={loading} - Assuming CBModal might take a loading prop
      >
        <div className="flex items-center"> {/* Optional: Add icon */}
           <FontAwesomeIcon icon={faTrashAlt} className="text-red-600 text-2xl mr-3" />
           <p>Are you sure you want to delete this account? Make sure there are no syncs!</p>
        </div>
      </CBModal>
    </>
  )
}

export default BoomerScan
